class ProductSearchController extends BaseSearchController
	@register()

	getContextLabel: (item) ->
		if item.context_label?
			return item.context_label

		item.context_label = item.entity_type.toLowerCase()

		return item.context_label

	setAdvancedSearch: ->
		if @ConfigurationService.isDisabled('Shared.Setting.Product.MultipleSku.Enabled')
			for configurationBlock in @searchData.advanced.configuration
				filters = configurationBlock.filters
				delete filters.sku?.options
				delete filters.variant_sku?.options

		super()
